export type { Article } from "./articlesData1";
import { articlesData1 } from "./articlesData1";
import { articlesData2 } from "./articlesData2";
import { articlesData3 } from "./articlesData3";
import { articlesData4 } from "./articlesData4";
import { articlesData5 } from "./articlesData5";

export const articles = [
  ...articlesData1,
  ...articlesData2,
  ...articlesData3,
  ...articlesData4,
  ...articlesData5,
];
